module.exports = window;


//////////////////
// WEBPACK FOOTER
// external "window"
// module id = 2390
// module chunks = 62